import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconControlKeyLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconControlKeyLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM9 6.68934L5.68934 10L6.75 11.0607L9 8.81066L11.25 11.0607L12.3107 10L9 6.68934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconControlKeyLeft;
